import {
  PENDING_CREDENTIAL,
  PENDING_CREDENTIAL_EMAIL,
} from '@assetron/web-common/constants/LocalStorageConstants';
import {
  linkWithCredential,
  OAuthCredential,
  UserCredential,
} from 'firebase/auth';

const checkAndHandlePendingCred = async (result: UserCredential) => {
  const pendingCredentialString =
    window.sessionStorage.getItem(PENDING_CREDENTIAL);
  const pendingCredEmail = window.sessionStorage.getItem(
    PENDING_CREDENTIAL_EMAIL,
  );

  try {
    if (
      pendingCredentialString &&
      pendingCredEmail &&
      pendingCredEmail === result.user.email
    ) {
      const pendingCredential = OAuthCredential.fromJSON(
        JSON.parse(pendingCredentialString),
      );
      await linkWithCredential(result.user, pendingCredential);
    }
  } catch (error) {
    console.error('Error linking pending credential:', error);
  }
};

export default checkAndHandlePendingCred;
